import React from 'react'
import "./BlogPost.css";

import cny from "../../Assets/b66/cny.jpg"

function Blog66() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Happy Chinese New Year! 🧧✨</h1>
                    <h6>February 17, 2026 at 10:00 AM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={cny} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>As we enter the Year of the Fire Horse, we welcome a year fueled by passion, strength, and unstoppable momentum. May this new year bring bold opportunities, steady growth, and the courage to chase bigger goals with confidence.</p>
                    <p>Here’s to prosperity, success, and meaningful partnerships in the year ahead. Gong Xi Fa Cai! 🐎🔥</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions </a>
                        <a href='https://www.facebook.com/hashtag/builttolast' target='_blank' className='blog-link'>
                        #BuildToLast </a>
                        <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
                        #TechForGood </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog66;
